import { forwardRef, useState, type SyntheticEvent } from 'react';
import { Tab } from './tab';
import { StyledTabs } from './tabs.styles';
import type { TabsProps } from './tabs.types';

export const Tabs = forwardRef<HTMLDivElement, TabsProps>(function Tabs(
  { items, onChange, defaultValue, ...rest },
  ref
) {
  const [selectedId, setSelectedId] = useState<string>(defaultValue ?? items[0].id);

  const handleChange = (event: SyntheticEvent, nextValue: string) => {
    setSelectedId(nextValue);
    onChange?.(event, nextValue);
  };

  return (
    <StyledTabs ref={ref} value={selectedId} onChange={handleChange} {...rest}>
      {items.map((item) => (
        <Tab key={item.id} value={item.id} label={item.label} disabled={item.disabled} />
      ))}
    </StyledTabs>
  );
});
